import React from 'react'

const Loader = () =>(
    <img className="loader" src={require('../img/loader.gif')} />
)

export default Loader;